import useSearchFilter from "hooks/useSearchFilter"
import PropTypes from "prop-types"
import React from "react"
import moment from "moment"
import Month from "./Views/Month"
import Week from "./Views/Week"
import Day from "./Views/Day"
import { BookingPopoverProvider } from "pagesV2/pro/Calendar/shared/BookingPopover/context"

const getCalendarComponent = () => {
  return { month: Month, week: Week, date: Day }
}

const CalendarViewSwitcher = ({ onChangeFilters, experienceIds, crewIds, equipmentIds, categoryIds, roleIds, startHour, endHour, showTimeRangeSettings, onStartHourChange, onEndHourChange, onResetHours }) => {
  const [params] = useSearchFilter({ accessAttributes: ["range", "date", "agenda", "tab", "listview"] })

  // Use today for month view if date is start of month
  const calendarDate = params.range === "month" && params.date === moment().startOf("month").format("YYYY-MM-DD")
    ? moment().format("YYYY-MM-DD")
    : params.date;

  if (!calendarDate || !params.range) return null
  const Calendar = getCalendarComponent()[params.range]

  return (
    <BookingPopoverProvider>
      <Calendar
        date={calendarDate}
        onChangeFilters={onChangeFilters}
        activeTab={params.tab}
        experienceIds={experienceIds}
        crewIds={crewIds}
        equipmentIds={equipmentIds}
        categoryIds={categoryIds}
        roleIds={roleIds}
        startHour={startHour}
        endHour={endHour}
        showTimeRangeSettings={showTimeRangeSettings}
        onStartHourChange={onStartHourChange}
        onEndHourChange={onEndHourChange}
        onResetHours={onResetHours}
      />
    </BookingPopoverProvider>
  )
}

CalendarViewSwitcher.propTypes = {
  onChangeFilters: PropTypes.func.isRequired,
  experienceIds: PropTypes.array,
  crewIds: PropTypes.array,
  equipmentIds: PropTypes.array,
  categoryIds: PropTypes.array,
  roleIds: PropTypes.array,
  startHour: PropTypes.number,
  endHour: PropTypes.number,
  showTimeRangeSettings: PropTypes.bool,
  onStartHourChange: PropTypes.func,
  onEndHourChange: PropTypes.func,
  onResetHours: PropTypes.func,
}

export default CalendarViewSwitcher
